import React from 'react';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Icon from '../../../../../../muiComponents/Icon';
import Tooltip from '../../../../../../muiComponents/Tooltip';
import useLanguage from '../../../../../../customHooks/useLanguage';
import { getOrdinalNumber } from '../../../../../../utils/usefulFunctions';

interface IconOtherAdultsProps {
    personNumber: number;
}
const IconOtherAdults = (props: IconOtherAdultsProps) => {
    const { personNumber } = props;
    const translate = useTranslate();
    const language = useLanguage();
    const otherAdultsTitle = `${getOrdinalNumber(
        personNumber,
        language
    )} ${translate('adult')}`;

    return (
        <div className='flex gap-5 flex-align-center'>
            <Icon
                iconName='Person'
                style={{
                    fontSize: 22,
                    color: 'var(--secondary-400)',
                }}
            />
            <Tooltip title={otherAdultsTitle}>
                <span>
                    <Icon
                        iconName={'InfoOutlined'}
                        sx={{
                            color: '#ffc107',
                            width: '12px',
                            height: '12px',
                            cursor: 'pointer',
                            marginBottom: '8px',
                        }}
                    />
                </span>
            </Tooltip>
        </div>
    );
};

export default IconOtherAdults;
